var wSize = $(window).outerWidth();
var hSize = $(window).innerHeight();

$(document).ready(function() {


    /* DATA AOS ---------------------------------- */

    $('[data-aos]').addClass('aos-init');

    /* ANNOUNCEMENT BAR -------------------------- */

    if ($('.announcement-bar').length) {
        $('.announcement-bar .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 30,
                autoplay: true,
                autoplayTimeout: 5000
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    /* MAIN -------------------------------------- */

    let headerHeight = $('.header-group').outerHeight();
    $('main').css('margin-top', `${headerHeight}px`);

    /* NAV MOBILE ITEMS --------------------------------- */
    
    header();

    /* POLICIES ----------------------------------------- */

    if ($('.policies').length) {
        $('.policies .wrapper a').each(function() {
            let href = $(this).attr('href');
            let currentPath = window.location.pathname;

            if (href && href.indexOf(currentPath) !== -1) {
                $(this).addClass('active');
            }
        });
    }

});

$(window).scroll(function() {
    header();
});

$(window).resize(function() {
    wSize = $(window).outerWidth();
    hSize = $(window).innerHeight();

    let abHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;

    if (!$('.announcement-bar').hasClass('hidden'))
        abHeight = 0;

    let headerHeight = $('.header-group').outerHeight();
    $('main').css('margin-top', `${headerHeight - abHeight}px`);
});

let lastScrollTop = 0;
function header() {
    if ($(window).scrollTop() >= 200)
        $('.header-group').addClass('scrolled');
    else
        $('.header-group').removeClass('scrolled');

    /* if (!$('.announcement-bar').hasClass('hidden')) {
        let currentScroll = $(window).scrollTop();
        let abHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;

        if (currentScroll > lastScrollTop) 
            $('.header-group').css('transform', `translateY(-${abHeight}px)`);
        else if (currentScroll < lastScrollTop)
            $('.header-group').css('transform', `translateY(0)`);

        lastScrollTop = currentScroll;
    } */
}

$('.announcement-bar .ab-hide').on('click', function() {
    $('.announcement-bar').addClass('hidden');

    let abHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;
    $('.header-group').css('transform', `translateY(-${abHeight}px)`);

    let headerHeight = $('.header-group').outerHeight();

    $('main').css('margin-top', `${headerHeight - abHeight}px`);
});

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function sectionPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let scrollPercentage = Math.min(100, Math.max(0, ((viewportHeight - elementTop) / elementHeight) * 100));

    return scrollPercentage;
}

function scrolledPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementTop = $element.offset().top;
    let elementBottom = elementTop + elementHeight;

    let distanceScrolled = scrollTop + viewportHeight - elementTop;

    let percent = (distanceScrolled / (elementHeight + viewportHeight)) * 100;

    percent = Math.max(0, Math.min(100, percent));

    return percent;
}


function isInFull($element) {
    let elementTop = $element.offset().top;
    let elementBottom = elementTop + $element.outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    let isFullyVisible = elementTop >= viewportTop && elementBottom <= viewportBottom;
    let isPartiallyVisibleTop = elementTop < viewportTop && elementBottom > viewportTop;
    let isPartiallyVisibleBottom = elementTop < viewportBottom && elementBottom > viewportBottom;

    if (isFullyVisible || (isPartiallyVisibleTop && isPartiallyVisibleBottom))
        return 'full';
    else if (isPartiallyVisibleTop)
        return 'partial-top';
    else if (isPartiallyVisibleBottom)
        return 'partial-bottom';
    else
        return 'none';
}

$('.header .nav-item').on('mouseover', function() {

    //$('.header .nav-items').find('.underline').css('width', '0');
    //$(this).find('.underline').css('width', '100%');

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.drop').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop[data-drop="' + dropValue + '"]');
        $drop.show();

        let navItemOffset = $this.offset();
        let navItemWidth = $this.outerWidth();
        let dropWidth = $drop.outerWidth();
        
        let leftPosition = navItemOffset.left + (navItemWidth / 2) - (dropWidth / 2);

        $drop.css({
            'left': leftPosition
        });
    }

});

let isMouseOverDrop = false;

$('.header .nav-items').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.navItemsCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverDrop) {
                $('.drop').hide();
                //$('.header .nav-items').find('.underline').css('width', '0');
            }
        }
    });
});

$('.header .nav-items').on('mouseenter', function() {
    $(document).off('mousemove.navItemsCheck');
});

$('.drop1').on('mouseenter', function() {
    isMouseOverDrop = true;
});

$('.drop1').on('mouseleave', function() {
    isMouseOverDrop = false;
    $('.header .nav-items').trigger('mouseleave');
});

$('.header .toggle-menu').on('click', function() {

    $('.nav-mobile').toggleClass('open');

    let headerHeight = $('.header-group').outerHeight();
    if ($('.header-group').css('transform') !== 'none') {
        let values = $('.header-group').css('transform').split('(')[1].split(')')[0].split(',');
        let translateY = values[5].trim();
        headerHeight = parseFloat(headerHeight) + parseFloat(translateY);
    }

    if ($('.product-nav').length) {
        headerHeight = headerHeight - $('.product-nav').height();
    }

    $('.nav-mobile').css('height', `${$(window).height() - headerHeight}px`);

    if ($('.nav-mobile').hasClass('open')) {
        $('body').css('overflow-y', 'hidden');

        $('.toggle-menu i').first().hide();
        $('.toggle-menu i').last().css('display', 'inline-block');
    }
    else {
        $('body').css('overflow-y', 'auto');

        $('.toggle-menu i').first().css('display', 'inline-block');
        $('.toggle-menu i').last().hide();

        $('.nav-mobile .mobile-mm').removeClass('active');
    }
});

$(document).on('click', '.nav-mobile .menu-items a', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $target = $(e.target);

    if ($target.is('span')) {
        const href = $target.parent('a').attr('href');
        
        window.location.href = href;
        return false;
    }
    else {
        let selector = $(this).data('dropmobile');

        $('.nav-mobile .mobile-mm').removeClass('active');
        $(`.nav-mobile .mobile-mm[data-selector="${selector}"]`).addClass('active');
    }
});

$('.nav-mobile .mm-header i').on('click', function() {
    $('.nav-mobile .mobile-mm').removeClass('active');
});

$('.main-article .share').on('click', function () {
    let article = $(this).data('article');

    if (navigator.share) {
        navigator.share({
            title: document.title,
            text: article,
            url: window.location.href
        }).catch(function (err) {
            console.error('Error sharing:', err);
        });
    } 
    else {
        alert('Sharing is not supported on this browser. Copy the URL instead: ' + window.location.href);
    }
});